import { cases } from '@/mocks/homeContent';

export default function CasesSection() {
  return (
    <section id="cases" className="w-full py-20 md:py-28 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center max-w-3xl mx-auto mb-8">
          <p className="font-mincho text-primary-600 tracking-widest text-sm md:text-base mb-3">
            CASE STUDIES
          </p>
          <h2 className="text-3xl md:text-5xl font-bold text-foreground-950 leading-snug">
            作業事例
            <span className="text-secondary-500 text-xl md:text-2xl align-middle ml-3">
              (掲載例)
            </span>
          </h2>
          <p className="mt-5 text-foreground-600 text-sm md:text-base leading-relaxed">
            京都 不用品回収・京都 遺品整理・京都 ゴミ屋敷清掃のイメージをつかんでいただくための掲載例です。
          </p>
        </div>

        <div className="mb-10 flex items-start gap-3 p-4 rounded-md bg-secondary-100 border border-secondary-200 text-secondary-900 text-xs md:text-sm">
          <span className="w-5 h-5 flex items-center justify-center shrink-0 mt-0.5">
            <i className="ri-information-2-line" />
          </span>
          <p>
            ※以下は実際の作業実績ではなく、内容・料金・所要時間のイメージをお伝えするための
            <strong>掲載例</strong>
            です。実際の料金は現地状況により変動しますので、無料お見積りをご利用ください。
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {cases.map((c) => (
            <article
              key={c.title}
              className="rounded-lg bg-background-100 border border-background-200 overflow-hidden hover:border-primary-300 transition-colors"
            >
              <div className="relative w-full h-52">
                <img
                  alt={`${c.location} ${c.type} 掲載例`}
                  className="w-full h-full object-cover object-top"
                  src={c.image}
                />
                <span className="absolute top-3 left-3 px-3 py-1 rounded-full bg-background-50/95 backdrop-blur text-foreground-900 text-xs font-bold">
                  {c.type}
                </span>
                <span className="absolute top-3 right-3 px-2 py-1 rounded-md bg-secondary-500 text-background-50 text-[10px] font-bold tracking-wider">
                  掲載例
                </span>
              </div>
              <div className="p-6">
                <div className="flex items-center gap-2 text-xs text-foreground-500 mb-2">
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-map-pin-line" />
                  </span>
                  <span>{c.location}</span>
                  <span className="w-px h-3 bg-background-300 mx-1" />
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-time-line" />
                  </span>
                  <span>{c.time}</span>
                </div>
                <h3 className="text-lg font-bold text-foreground-950 mb-3 leading-snug">
                  {c.title}
                </h3>
                <p className="text-foreground-700 text-sm leading-relaxed mb-4">
                  {c.desc}
                </p>
                <div className="flex items-end justify-between pt-4 border-t border-background-200">
                  <span className="text-xs text-foreground-500">掲載例料金</span>
                  <span className="font-mincho text-2xl font-bold text-primary-600">
                    {c.price}円
                    <span className="text-xs text-foreground-500 ml-1">(税込)</span>
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}